// EncodingUtils.ts
// Utility functions for base64 encoding/decoding and gzip compression/decompression
import pako from 'pako';

// Base64 encode a string or Uint8Array (handles UTF-8)
export function base64Encode(input: string | Uint8Array): string {
    let bytes: Uint8Array;
    if (typeof input === 'string') {
        bytes = new TextEncoder().encode(input);
    } else {
        bytes = input;
    }
    // Convert bytes to binary string
    let binary = '';
    for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}

// Base64 decode to Uint8Array or string (UTF-8)
export function base64Decode(base64: string, toString = false): Uint8Array | string {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    if (toString) {
        return new TextDecoder().decode(bytes);
    }
    return bytes;
}

// Gzip compress a string or Uint8Array, returns Uint8Array
export function gzipCompress(input: string | Uint8Array): Uint8Array {
    let bytes: Uint8Array;
    if (typeof input === 'string') {
        bytes = new TextEncoder().encode(input);
    } else {
        bytes = input;
    }
    return pako.gzip(bytes);
}

// Gzip decompress a Uint8Array, returns string or Uint8Array
export function gzipDecompress(input: Uint8Array, toString = false): Uint8Array | string {
    const result = pako.ungzip(input);
    if (toString) {
        return new TextDecoder().decode(result);
    }
    return result;
} 